export default (gridIds, maxIndex) => {
  // produces a string id that will allow us to see if the top grid elements
  // change. 0 for spotlight, 1 or higher of conversation.
  if (!gridIds || gridIds.length === 0) return '';
  let id = `${gridIds[0] ? gridIds[0] : ''}`;
  for (let i = 1; i <= maxIndex; i += 1) id += `:${gridIds[i] ? gridIds[i] : ''}`;
  return id;
};
